import { injectable } from "@codemation/core";
import type { IWorkflowAuditEmitter, WorkflowAuditEntry } from "./IAuditEmitter";

@injectable()
export class NoOpWorkflowAuditEmitter implements IWorkflowAuditEmitter {
  emit(_entry: WorkflowAuditEntry): Promise<void> {
    return Promise.resolve();
  }
}
